import { maxBarsForLabels } from '../charts';

export function useBarLabelFormatter({ totalBarCount }: { totalBarCount: number }) {
  return (value: number) => {
    if (value === 0 || totalBarCount > maxBarsForLabels) {
      return null;
    }

    return value;
  };
}
